import { createReducer, on } from '@ngrx/store';
import * as RulesActions from '../actions/rules-actions';
import { iRulesState, RuleData } from '@app/Shared/interfaces/iRules';

export const initialRulesState: iRulesState = {
    rules: [],
    selectedRule: null,
    isLoading: false,
    error: null,
};

export const rulesReducer = createReducer(
    initialRulesState,

    // Load Rules
    on(RulesActions.loadRules, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),

    on(RulesActions.loadRulesSuccess, (state, { rules }) => ({
        ...state,
        rules,
        isLoading: false,
        error: null,
    })),

    on(RulesActions.loadRulesFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // Create Rule
    on(RulesActions.createRule, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),

    on(RulesActions.createRuleSuccess, (state, { rule }) => ({
        ...state,
        rules: [...state.rules, rule],
        isLoading: false,
        error: null,
    })),

    on(RulesActions.createRuleFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // Update Rule
    on(RulesActions.updateRule, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),

    on(RulesActions.updateRuleSuccess, (state, { rule }) => ({
        ...state,
        rules: state.rules.map((r) => (r.DataFieldRuleKey === rule.DataFieldRuleKey ? rule : r)),
        selectedRule: state.selectedRule?.DataFieldRuleKey === rule.DataFieldRuleKey ? rule : state.selectedRule,
        isLoading: false,
        error: null,
    })),

    on(RulesActions.updateRuleFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // Delete Rule
    on(RulesActions.deleteRule, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),
on(RulesActions.deleteRuleSuccess, (state, { key }) => ({
        ...state,
        rules: state.rules.filter((r) => r.DataFieldRuleKey !== key),
        selectedRule: state.selectedRule?.DataFieldRuleKey === key ? null : state.selectedRule,
        isLoading: false,
        error: null,
    })),

    on(RulesActions.deleteRuleFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // Select Rule
    on(RulesActions.selectRule, (state, { rule }) => ({
        ...state,
        selectedRule: rule,
    })),

    on(RulesActions.clearSelectedRule, (state) => ({
        ...state,
        selectedRule: null,
    }))
);
